import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlarmClock } from "lucide-react";
import { api } from "../../lib/api";
import { formatRupiah, formatDay } from "../../lib/labels";

export const OverdueImbalanCard = ({ base }) => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/profit/imbalan-overdue").then((r) => setItems(r.data.items)).catch(() => setItems([]));
  }, []);
  if (!items?.length) return null;
  return (
    <section className="mb-6 rounded-xl border border-amber-300 bg-amber-50 p-4 sm:p-5" data-testid="overdue-imbalan-card">
      <p className="flex items-center gap-2 font-bold text-amber-950"><AlarmClock className="h-4 w-4" />Imbalan Jasa PT SJI belum dibayar ({items.length})</p>
      <p className="mt-1 text-xs text-amber-900">Lebih dari 14 hari sejak hasil penjualan dihitung. Mohon bayar dan laporkan bukti transfer.</p>
      <ul className="mt-3 divide-y divide-amber-200">{items.map((i) => (
        <li key={i.id} className="flex flex-col gap-1 py-2 sm:flex-row sm:items-center sm:justify-between" data-testid={`overdue-imbalan-${i.id}`}>
          <span className="text-sm text-slate-900"><b>{i.projectCode || "-"}</b> · penjualan {formatDay(i.saleDate)} · <b className="font-mono">{formatRupiah(i.amount)}</b> · {i.daysPending} hari</span>
          <Link to={`${base}/bagi-hasil/${i.contractId}?tab=laporan`} className="text-xs font-semibold text-emerald-800 underline" data-testid={`overdue-imbalan-open-${i.id}`}>Laporkan pembayaran</Link>
        </li>))}</ul>
    </section>
  );
};
